import { ccfRoutes } from '@app/ccf/ccf-routes';
import { Icons } from '@shared/components/content/icons';
import Text from '@shared/components/content/text';
import GuideLayout from '@shared/components/guide-layout';
import GuideTemplate from '@shared/components/guide-template';
import { Card, CardContent } from '@shared/components/ui/card';
import { generatePath, Link, useNavigate, useParams } from 'react-router-dom';

export default function SupplyChainLogisticsFlows() {
  const navigate = useNavigate();
  const params = useParams();
  const companyReportUuid = params.report_uuid;

  const flows = [
    {
      icon: <Icons.arrowRight className="text-orange-400" size={20} />,
      title: 'Supply of purchased goods',
      description:
        'The transportation of your purchased goods, from when they leave your supplier to when they arrive at your sites.',
      href: generatePath(ccfRoutes.SUPPLY_FLOW_INTRO, {
        report_uuid: companyReportUuid,
      }),
    },

    {
      icon: <Icons.truck className="text-orange-400" size={20} />,
      title: 'Distribution of products',
      description:
        'The transportation of your products, anywhere between your sites, on to your clients and all the way to the end consumer.',
      href: generatePath(ccfRoutes.DISTRIBUTION_FLOW_INTRO, {
        report_uuid: companyReportUuid,
      }),
    },
  ];
  return (
    <GuideLayout
      pageName="Transportation and distribution flows"
      className="from-primary-100 to-primary-50"
      onClosePath={generatePath(
        ccfRoutes.SUPPLY_CHAIN_LOGISTICS, // You may want a list route here
        {
          report_uuid: companyReportUuid,
        }
      )}
    >
      <GuideTemplate
        preTitle="Transport and distribution"
        title="Add a flow"
        description="We’ve divided your transport and distribution emissions into two broad stages, supply of purchased goods and distribution of products. The emissions of each stage can be expressed as simple flows that estimate the emissions at a high-level. You can create as many of each type of flow as you need to sufficiently model your supply chain."
        primaryActionText="Add flow"
        primaryActionProps={{
          style: { display: 'none' }, // Hide the primary action button
        }}
      >
        <div>
          {flows.map((flow, index) => {
            return (
              <Link to={flow.href} className="no-underline" key={index}>
                <Card
                  key={index}
                  className="mb-6 flex max-w-lg items-center text-left shadow-md"
                >
                  <div>
                    <CardContent className="flex items-center px-4 pb-2 pt-4">
                      {flow.icon}
                      <span className="ml-2 text-md">{flow.title}</span>
                    </CardContent>
                    <CardContent className="px-4 pb-4">
                      <Text variant="subtle">{flow.description}</Text>
                    </CardContent>
                  </div>
                  <div className="pr-4">
                    <Icons.chevronRight className="text-gray-400" />
                  </div>
                </Card>
              </Link>
            );
          })}
        </div>
      </GuideTemplate>
    </GuideLayout>
  );
}
